// Polyfills for browsers that lag behind our JS dependencies.
// pdf.js 4.x uses Promise.withResolvers(), a Baseline-2024 feature.
// Safari < 17.4, Firefox < 121, and older Chromium builds don't have it yet.
// Adding this tiny shim keeps the annotator working on older machines.
if (typeof Promise.withResolvers !== "function") {
    Promise.withResolvers = function withResolvers() {
        let resolve;
        let reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}
